import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  title: {
    fontSize: 40,
    color: theme.colorPalette.green_75
  },
  divider: {
    margin: 0
  },
  formSubtitle: {
    paddingBottom: '0px !important'
  },
  applyDiscountBtn: {
    width: 200
  },
  removeDiscountBtn: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center'
  },
  removeIcon: {
    width: 24,
    height: 24,
    marginRight: 8
  },
  buttonContainer: {
    marginTop: theme.spacing(8)
  }
}));
